import { X } from "lucide-react";
import React, { useEffect, useState } from "react";
import { Modal } from "react-bootstrap";
import "react-date-range/dist/styles.css"; // main css file
import "react-date-range/dist/theme/default.css"; // theme css file
import { DateRangePicker } from "react-date-range";
import { addDays, format } from "date-fns";

const DateRangePickerCom = ({ showDateRange, setSelectedButton, setShowDateRange, setFilterSelected, setState, state }) => {

  // addDays(new Date(), 7)
  useEffect(() => {
    // if(showDateRange){
    //   setState([
    //     {
    //       startDate:new Date(),
    //       endDate: new Date(),
    //       key: "selection",
    //     },
    //   ])
    // }
  }, [showDateRange])

  return (
    <div className="">
      <Modal
        show={showDateRange}
        onHide={() => setShowDateRange(false)}
        size="lg"
        aria-labelledby="contained-modal-title-vcenter"
        centered
        className="datePickerModal"
      >
        <Modal.Body className="!p-0">
          <button
            className="absolute right-[5px] top-[5px] text-white"
            onClick={() => setShowDateRange(false)}
          >
            <X size={30} strokeWidth={1.5} color="black" />
          </button>
          <div className="bg-white rounded-xl p-2">
            <h2 className=" text-[18px] font-medium text-[#333333]">
              Custom Filters
            </h2>
            <DateRangePicker
              onChange={(item) => {
                setState([item.selection])
              }
              }
              showSelectionPreview={true}
              moveRangeOnFirstSelection={false}
              months={2}
              ranges={state}
              direction="horizontal"
            />
          </div>
          <div className="flex items-center justify-center gap-3 pb-3">
            <button
              onClick={() => {
                setShowDateRange(false)
                setSelectedButton('All')
              }
              }
              className="py-2 px-3 rounded-lg  border border-[#333333] text-black font-medium text-[16px]"
            >
              Cancel
            </button>
            <button className="py-2 px-3 rounded-lg bg-primaryColor text-white font-medium text-[16px]"
              onClick={() => {

                setFilterSelected((prev) => ({ ...prev, date_range_after: format(state[0]?.startDate, 'yyyy-MM-dd') }))
                setFilterSelected((prev) => ({ ...prev, date_range_before: format(state[0]?.endDate, 'yyyy-MM-dd') }))
                setShowDateRange(false)
              }}
            >
              ok
            </button>
          </div>
        </Modal.Body>
      </Modal>
    </div>
  );
};

export default DateRangePickerCom;
